import { Box, Divider, Typography } from "@material-ui/core/"
import { useStaticQuery, graphql } from "gatsby"
import React from "react"

import ItemList from "./ItemList"

import openSourcesList from "../../../content/opensources/opensources.yml"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  divider: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    width: "100%",
  },
  root: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    marginBottom: 32,
    marginTop: 4,
    width: "100%",
  },
  section: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(0),
      marginTop: theme.spacing(0),
    },
  },
  title: {
    fontSize: "2rem",
    fontWeight: 700,
    textAlign: "center",
    width: "40%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}))

const OpenSourceContainer = () => {
  const classes = useStyles()

  const data = useStaticQuery(graphql`
    query OpensourcesPicsQuery {
      allFile(
        filter: {
          absolutePath: { regex: "/content/images/dbsystem-opensources/" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              fixed(height: 120) {
                originalName
                src
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
    }
  `)

  return (
    <div className={classes.root}>
      <Box className={classes.section}>
        {/* <Typography component="h2" variant="h5" className={classes.title}>
          AI + Finance
        </Typography> */}

        <ItemList
          images={data.allFile.edges}
          data={openSourcesList}
          group="openSource"
        />
      </Box>

      {/* <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography component="h2" variant="h5" className={classes.title}>
          AI + Healthcare
        </Typography>

        <ItemList
          images={data.allFile.edges}
          data={openSourcesList}
          group="healthcare"
        />
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography component="h2" variant="h5" className={classes.title}>
          AI + Structured Data
        </Typography>

        <ItemList
          images={data.allFile.edges}
          data={openSourcesList}
          group="structured_data"
        />
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography component="h2" variant="h5" className={classes.title}>
          AI + DB for Cohort Discovery and Analytics
        </Typography>

        <ItemList
          images={data.allFile.edges}
          data={openSourcesList}
          group="cohort_network"
        />
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography component="h2" variant="h5" className={classes.title}>
          AI + DB for Food Analytics and 3H Management
        </Typography>

        <ItemList
          images={data.allFile.edges}
          data={openSourcesList}
          group="food_analytics"
        />
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography component="h2" variant="h5" className={classes.title}>
          Blockchain
        </Typography>

        <ItemList
          images={data.allFile.edges}
          data={openSourcesList}
          group="blockchain"
        />
      </Box>

      <Divider className={classes.divider} />

      <Box className={classes.section}>
        <Typography component="h2" variant="h5" className={classes.title}>
          Data Collaboration
        </Typography>

        <ItemList
          images={data.allFile.edges}
          data={openSourcesList}
          group="data_collaboration"
        />
      </Box> */}
    </div>
  )
}

export default OpenSourceContainer
